import { createSlice } from '@reduxjs/toolkit'
import { axiosClient } from '../../services/axiosInstance'

export const slice = createSlice({
  name: 'myProgress',
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
    myProgressData: null,
  },
  reducers: {
    getMyProgressRequest: (state) => {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isFail: false,
      }
    },
    getMyProgressSuccess: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isFail: false,
        myProgressData: action.payload,
      }
    },
    getMyProgressFail: (state) => {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isFail: true,
      }
    },
  },
})

export default slice.reducer

export const {
  getMyProgressRequest,
  getMyProgressSuccess,
  getMyProgressFail,
} = slice.actions

export const getMyProgress = (userId) => async (dispatch) => {
  dispatch(getMyProgressRequest())
  try {
    const response = await axiosClient.get(`/User/MyProgress/${userId}`)
    dispatch(getMyProgressSuccess(response.data))
  } catch {
    dispatch(getMyProgressFail())
  }
}
